import { Component, ElementRef, Input, HostListener, OnChanges, SimpleChanges } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';



@Component({
    selector: 'pb-export-to-excel',
    template: `<a>
    <svg class="xls_icon" shape-rendering="geometricPrecision">
            <use xlink:href="./assets/images/icons/symbols.svg#icon_xls"></use>
    </svg>
</a>`
})
export class ExporttoexcelComponent {

    @Input() data: any;
    pagename: string = 'IGL Smart Card Report';
    constructor(el: ElementRef) {
    }
    @HostListener('click', ['$event']) onclick() {
        this.data().subscribe(a => {
            this.exportAsExcelFile(a, this.pagename);
        });
    }

    public exportAsExcelFile(json: any[], excelFileName: string): void {
        if (json != null && json.length > 0) {
            const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
            const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
            this.saveAsExcelFile(excelBuffer, excelFileName);
        }
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_' + this.formattedDate() + EXCEL_EXTENSION);
    }

    formattedDate() {
        const d = new Date();
        let month = String(d.getMonth() + 1);
        let day = String(d.getDate());
        const year = String(d.getFullYear());

        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }

        return `${month}${day}${year}`;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/common/excel-export.component.ts